import type { Filter } from '@cubejs-client/core'
import {
  CONVERSATION_FACTS_DIMENSIONS,
  CONVERSATION_FACTS_ZONE_DIMENSIONS,
} from 'cube'
import { Moment } from 'moment'
import * as R from 'ramda'

import { type CubeQuery, CubeQueryBuilder } from '@driftt/dds.reports'

export const formatHeatMapDrillDownQuery = (
  hourOfDay: string,
  dayOfWeek: string,
  startDate: Moment,
  endDate: Moment,
  filters: Filter[]
): CubeQuery => {
  return new CubeQueryBuilder({})
    .withName(`ConversationHeatMapDrillDown-${hourOfDay}-${dayOfWeek}`)
    .withQueryName(`ConversationHeatMapDrillDown-${hourOfDay}-${dayOfWeek}`)
    .withDimensions([
      CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT,
      CONVERSATION_FACTS_DIMENSIONS.DURATION_BETWEEN_FIRST_INTERACTION_AND_FIRST_CLOSE_MS,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_FROM_URL,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_ID,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_STATUS,
    ])
    .withinDateRange(
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_AT,
      startDate.toDate(),
      endDate.toDate()
    )
    .withFilters([
      {
        member: CONVERSATION_FACTS_DIMENSIONS.HOUR_OF_DAY,
        operator: 'equals',
        values: [hourOfDay.toString()],
      },
      {
        member: CONVERSATION_FACTS_DIMENSIONS.DAY_OF_WEEK,
        operator: 'equals',
        values: [dayOfWeek],
      },
      ...filters,
    ])
    .withOrder([
      [CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT, 'desc'],
    ])
    .build()
}

/**
 * Maps day abbreviations to numbers. Used to format day values in the conversations heat map series data.
 */
export const DayToNumberMap = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
}

/**
 * Used for mapping a given number to the corresponding day string abbreviation.
 * @param day number
 * @returns string
 */
export const getDayAsString = (day: number): string => {
  return (
    Object.keys(DayToNumberMap).find((key) =>
      R.equals(DayToNumberMap[key], day)
    ) ?? ''
  )
}
